import { render, staticRenderFns } from "./problemCompletionRate.vue?vue&type=template&id=71421f7c&scoped=true&"
import script from "./problemCompletionRate.vue?vue&type=script&lang=js&"
export * from "./problemCompletionRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71421f7c",
  null
  
)

export default component.exports